import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "index-page",
  "dark-class": "index-page-dark"
}
const _hoisted_2 = { id: "menu-mobile" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "sidebar" }
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "main-menu-pc" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "main-menu-pc" }
const _hoisted_14 = ["href", "title"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "column-box" }
const _hoisted_18 = { class: "head-box" }
const _hoisted_19 = { class: "page-name" }
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "operating-box" }
const _hoisted_23 = {
  class: "search-box",
  id: "SearchBox"
}
const _hoisted_24 = { class: "search" }
const _hoisted_25 = { class: "icon-box" }
const _hoisted_26 = { class: "search-input" }
const _hoisted_27 = { class: "search-result" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "path" }
const _hoisted_31 = { class: "btn-box" }
const _hoisted_32 = {
  key: 0,
  class: "user-box"
}
const _hoisted_33 = { class: "avatar-box" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "status" }, null, -1)
const _hoisted_36 = { class: "btn-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_comp_menu = _resolveComponent("comp-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page_about = _resolveComponent("page-about")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, idx) => {
          return (_openBlock(), _createElementBlock("li", { key: idx }, [
            _createElementVNode("a", {
              href: item.href,
              child: ""
            }, _toDisplayString(item.name), 9, _hoisted_3),
            (item.child)
              ? (_openBlock(), _createElementBlock("ul", {
                  key: 0,
                  innerHTML: _ctx.getMobileMenuChild(item.child)
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.setting_info.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "icon",
              src: _ctx.setting_info.icon.url
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["menu-item", { 'menu-item-activity': _ctx.d_menu_root === menu.root }]),
            key: idx
          }, [
            _createElementVNode("a", {
              class: "menu-item-box",
              href: menu.href
            }, [
              _createElementVNode("img", {
                class: "icon",
                src: 'static/icon/menu_icon/' + menu.icon
              }, null, 8, _hoisted_10),
              _createElementVNode("p", _hoisted_11, _toDisplayString(menu.name), 1)
            ], 8, _hoisted_9),
            (menu.child)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "menu-child-base menu-child-box",
                  innerHTML: _ctx.getMenuChild(menu.child),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideMenuChild()))
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submenus, (menu, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["menu-item", { 'menu-item-activity': _ctx.d_menu_root === menu.root }]),
            key: idx
          }, [
            _createElementVNode("a", {
              class: "menu-item-box",
              href: menu.href,
              title: menu.name
            }, [
              _createElementVNode("img", {
                class: "icon",
                src: 'static/icon/menu_icon/' + menu.icon
              }, null, 8, _hoisted_15)
            ], 8, _hoisted_14),
            (menu.child)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "menu-child-base menu-child-box",
                  innerHTML: _ctx.getMenuChild(menu.child),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideMenuChild()))
                }, null, 8, _hoisted_16))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "menu-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menu.open()))
          }, [
            _createVNode(_component_elem_icon, { name: "menu" })
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(), _createBlock(_component_elem_icon, {
              src: "static/icon/menu_icon/",
              key: _ctx.page_icon,
              name: _ctx.page_icon
            }, null, 8, ["name"]))
          ]),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.page_title), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: _normalizeClass(["search-base", { 'search-activity': _ctx.display_search }])
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_elem_icon, { name: "search_white" })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    placeholder: "搜索功能模块",
                    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchInputBlur && _ctx.onSearchInputBlur(...args))),
                    onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSearchInputFocus && _ctx.onSearchInputFocus(...args))),
                    onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args))),
                    onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["enter"]))
                  }, null, 32)
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.search_result, (item, idx) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "result-item",
                    key: idx,
                    href: item.href
                  }, [
                    _createElementVNode("p", _hoisted_29, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(item.href), 1)
                  ], 8, _hoisted_28))
                }), 128))
              ], 512), [
                [_vShow, _ctx.display_search && _ctx.search_result && _ctx.search_result.length > 0]
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            class: "btn-box",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.jump('/message')))
          }, [
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "notice_white",
              hover: "#2faaf7",
              width: "20px",
              height: "20px"
            })
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "setting_white",
              hover: "#2faaf7",
              width: "20px",
              height: "20px"
            }),
            _createVNode(_component_comp_menu, {
              value: _ctx.settingMenu,
              onSelect: _ctx.onSelectSettingMenu
            }, null, 8, ["value", "onSelect"])
          ]),
          (_ctx.userinfo && _ctx.userinfo.avatar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("img", {
                    class: "avatar",
                    src: _ctx.userinfo.avatar.url
                  }, null, 8, _hoisted_34),
                  _hoisted_35
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_elem_icon, { name: "arrow_bottom_white" })
                ]),
                _createVNode(_component_comp_menu, {
                  value: _ctx.userMenu,
                  onSelect: _ctx.onSelectUserMenu
                }, null, 8, ["value", "onSelect"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["content-box", { 'online-activity': _ctx.isDisplayOnlineServicePage }]),
        "dark-class": "content-dark",
        id: "Content"
      }, [
        _createElementVNode("div", {
          class: "content-scroll",
          onScroll: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 1
          })
        ], 32)
      ], 2)
    ]),
    _createVNode(_component_page_about)
  ]))
}